import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';

export class GenericInfoDialog implements IDialog {
    options: IDialogOptions;
    contentText: string;

    constructor(titleText: string, contentText: string) {
        this.options = {
            title: titleText
        };
        this.contentText = contentText;
    }

    content(): JQuery {
        return $('<div />').text(this.contentText);
    }
}